@if (status === 'form') {
  <!-- DDA Form -->
  <section
    class="dda-modal-content"
    [formGroup]="form"
  >
    <p class="dda-description">
      {{ description }}
    </p>

    @if (loading$ | async) {
      <caixa-webcomponent-shimmer
        class="dda-account-shimmer"
        [height]="'56px'"
        [borderRadius]="'4px'"
        [marginBottom]="'40px'"
      />
    } @else {
      <label
        class="dda-label"
        for="dda-account"
      >
        Conta
      </label>
      <cds-checking-account-dropdown
        id="dda-account"
        [formControlName]="'checking_account'"
        [placeholderInput]="'Conta bancária p/ boletos a pagar'"
        [checkingAccounts]="checkingAccounts"
      />
    }

    <p class="dda-footnote">
      A conta escolhida será aplicada para todos os novos boletos registrados a partir de agora.
      Boletos já existentes não serão alterados.
    </p>

    <button
      type="button"
      class="dda-config-link"
      (click)="requestDdaAuthorization()"
    >
      Nenhuma previsão de boleto a pagar apareceu? Clique aqui para configurar o buscador de boletos
    </button>

    <button
      class="cds-button s-solid c-primary"
      cdsButtonLoading
      [loading]="isSaving"
      [disabled]="!canSave"
      (click)="save()"
    >
      Salvar alterações
    </button>
  </section>
  <!-- ! DDA Form -->
} @else {
  <!-- DDA Result -->
  <section class="dda-result-state">
    @if (status === 'success') {
      <i class="cds-icon-filled-check status-icon success"></i>
    } @else {
      <i class="cds-icon-filled-alert-triangle status-icon error"></i>
    }

    <h3 class="result-title">
      {{ status === 'success' ? successTitle : errorTitle }}
    </h3>

    <p class="result-description">
      {{ status === 'success' ? successDescription : errorDescription }}
    </p>

  </section>
  <!-- ! DDA Result -->
}
